import { render, staticRenderFns } from "./AreaEmbargadaCePonto.vue?vue&type=template&id=3c7ad31c&lang=pug"
import script from "./AreaEmbargadaCePonto.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaCePonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports